export type LoginContext = {
  isLoggedIn: boolean;
  userId?: string;
};

const loginContext = $state<{ value: LoginContext }>({
  value: {
    isLoggedIn: false,
    userId: undefined,
  },
});

export const setLoginContext = (newLoginContext: LoginContext): void => {
  loginContext.value = newLoginContext;
};

export const getLoginContext = (): LoginContext => {
  return loginContext.value;
};
